import React from "react";
import { Grid, Accordion, Pagination } from "semantic-ui-react";
import "../auth.css";
import "../card.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Table from "react-bootstrap/Table";
import {
  Message,
  Icon,
  Label,
  Menu,
  List,
  Segment,
  Header,
  Button,
  Divider,
  Input,
  Form,
  Card,
  Modal,
  TextArea,
  Checkbox,
  Radio,
  Item,
  Image,
} from "semantic-ui-react";
import { API_BASE_URL } from "../utils/endpoints";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import Select from "react-select";

//import Modal from "react-modal";
import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/dist/style.css";
var groupOptions = [];
//////////// editContact.js ////////////
var value_option = [];
var groupOptions = [];
var groups_array = [];
var data_group = [];

const formData = new FormData();
var total_success,
  total_failed = 0;

const AddContact = {
  height: "auto",
  width: 700,
  marginLeft: "30%",
  marginTop: 100,
};

const AddContacta = {
  height: "auto",
  width: 700,
  marginLeft: "15%",
  marginTop: 100,
};

const DeleteContact = {
  height: "auto",
  width: 700,
  marginLeft: "30%",
  marginTop: 200,
};

const DeleteContacta = {
  height: "auto",
  width: 700,
  marginLeft: "15%",
  marginTop: 200,
};

class Contact extends React.Component {
  state = { activeIndex: 0 };
  constructor(props) {
    super(props);
    this.state = {
      persons: [],
      personssearch: [],
      groups: [],
      isLoading: true,
      errors: null,
      id: "",
      query: "",
      totalpage: 1,
      activePage: 1,
      displayViewBox: false,

      exportFlag: false,

      searchtotalpage: 1,

      group_name: "",
      isArabic: false,
      viewDatadownload: "",
      IsOpenDeleteContact: false,
      contactIdForeDelet: "",
      contactNameForeDelete: "",
      searchWord: "",
      modalOpenAddContact: false,
      modalOpenUploadFile: false,
      modalOpenEditContact: false,
      modalOpenDeleteContact: false,

      ///////////add_contact.js/////////
      mobile: "",
      firstname: "",
      secondname: "",
      familyname: "",
      job: "",
      company: "",
      groupselect: "",
      group_id: "",
      selectedValues: [],
      options_sender: [],
      Delete_Contact: [],
      options_senders: [],
      custom_filter1: "",
      custom_filter2: "",
      custom_filter3: "",
      custom_filter4: "",
      custom_filter5: "",
      custom_filter6: "",
      area: "",
      country: "",
      district: "",
      governerate: "",
      ////////////////////// import file.js/////////////
      uploadfile: [],
      products: [
        { label: "Foo", value: 1 },
        { label: "Bar", value: 2 },
        { label: "Baz", value: 3 },
        { label: "Fuz", value: 4 },
      ],
      selectedValues: [],
      dataresult: [],
      modalIsOpen: false,
      show: false,
      collapsed: false,
      collapseID: "",
      options_sender: [],
      isArabic: false,
    };

    this.openModalDeleteContact = this.openModalDeleteContact.bind(this);
    this.closeModalDeleteContact = this.closeModalDeleteContact.bind(this);
  }

  handleOpenAddContact = () => this.setState({ modalOpenAddContact: true });
  handleCloseAddContact = () => this.setState({ modalOpenAddContact: false });
  handleOpenUploadFile = () => this.setState({ modalOpenUploadFile: true });
  handleCloseUploadFile = () => this.setState({ modalOpenUploadFile: false });
  handleOpenEditContact = () => this.setState({ modalOpenEditContact: true });
  handleCloseEditContact = () => this.setState({ modalOpenEditContact: false });
  handleOpenDeleteContact = () =>
    this.setState({ modalOpenDeleteContact: true });
  handleCloseDeleteContact = () =>
    this.setState({ modalOpenDeleteContact: false });

  closeModalDeleteContact() {
    this.setState({ IsOpenDeleteContact: false });
  }
  openModalDeleteContact(e) {
    this.setState({
      modalOpenDeleteContact: true,
      contactIdForeDelet: e.target.id,
      contactNameForeDelete: e.target.name,
    });
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        e.target.id +
        "/findcontact";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        e.target.id +
        "/findcontact";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data !== undefined) {
        var length = res.data.result.contact.groups.length;
        var i;
        var array = [];
        for (i = 0; i < length; i++) {
          array.push(res.data.result.contact.groups[i].label);
        }
        this.setState({ group_name: array });
      }
    });
  };

  EditContactform = (event) => {
    event.preventDefault();
    console.log(event.target.id);
    // this.setState({ id: event.target.id });
    //  reactLocalStorage.set("id_user_edit", event.target.id);
    //reactLocalStorage.get("id_user_edit");

    this.setState({ modalOpenEditContact: true });
    this.goToEdit();
    this.EditDidMount();
  };

  AddToDelete = (event) => {
    console.log(event.target.id);
    console.log(event.target.checked);
    if (event.target.checked == true) {
      if (this.state.Delete_Contact.includes(event.target.id) == false) {
        this.state.Delete_Contact.push(event.target.id);
      }
    } else {
      var index;
      if (this.state.Delete_Contact.includes(event.target.id) == true) {
        index = this.state.Delete_Contact.indexOf(event.target.id);
        console.log(index);
        this.state.Delete_Contact.splice(index, 1);
      }
    }
    if (this.state.Delete_Contact.length > 0) {
      this.setState({
        DeleteFlag: true,
      });
    } else {
      this.setState({
        DeleteFlag: false,
      });
    }

    console.log(this.state.Delete_Contact);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");

    this.setState({ id: event.target.id });

    var ip = API_BASE_URL;
    
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        reactLocalStorage.get("id") +
        "/deleteContact";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +reactLocalStorage.get("user_id_login")+'/'+reactLocalStorage.get("id")+"/deleteContact";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, {}, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.status,
              animation: "bounce",
              time: 5000,
            });
            window.location = "contact";
          }
          window.location = "contact";
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleDelete = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");

    this.setState({ id: event.target.id });

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var body = {
      contactIds: this.state.Delete_Contact,
    };
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        "/deleteMultipleContact";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        "/deleteMultipleContact";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, body, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "deleted successfully") {
            window.location = "contact";
          } else {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.status,
              animation: "bounce",
              time: 5000,
            });
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  componentWillMount() {
    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");

    var page_num = this.state.activePage - 1;
    var data = { searchQuery: "", page: page_num };
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/searchUserContacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/searchUserContacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.status === "failed") {
        alert("token change");
      }
      if (res.data.result.contacts !== undefined) {
        const persons = res.data.result.contacts;
        if (res.data.result.contacts.length == 0) {
          //document.querySelector('.icon2').style='display:none'
        }
        var data_group;
        var i;

        for (i = 0; i < persons.length; i++) {
          data_group = persons[i].groups;
        }

        if (res.data.result.contacts != undefined) {
          if (res.data.result.contacts_count === 0) {
            this.setState({ exportFlag: false });
          } else {
            this.setState({ exportFlag: true });
          }
          var total = Math.ceil(res.data.result.contacts_count / 20);
          this.setState({ totalpage: total });
          this.setState({ persons });

          this.setState({ groupss: data_group });
        }
      }
    });
  }
  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".darked_color").style =
        "text-align:right;width: 20%;white-space: pre;";

      document.querySelector(".ui.pagination.menu").style =
        "float: left !important; margin-left: 4% !important;";
      document.querySelector(".main_contact").style = "margin-right: 1%;";

      document.querySelector(".fixed_contact").style =
        "margin-right: 0% !important;";
    }
  }
  open = () => {};

  searchchange = (event) => {
    // window.scrollTo(0, 0);
    reactLocalStorage.set("flag", true);
    this.setState({ searchWord: event.target.value });
    if (event.target.value == "" || event.target.value.length >= 2) {
      document.querySelector(".pagination").style = "display:none";
      document.querySelector(".searchpagination").style = "display:block";
      var token = reactLocalStorage.get("accessToken");
      reactLocalStorage.get("user_id_login");

      var page_num = this.state.activePage - 1;
      var data = { searchQuery: event.target.value, page: 0 };
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/searchUserContacts";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/searchUserContacts";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        if (res.data.status === "failed") {
          alert("token change");
        }
        if (res.data.result.contacts !== undefined) {
          const persons = res.data.result.contacts;
          if (res.data.result.contacts.length == 0) {
            //  document.querySelector('.icon2').style='display:none'
          }
          var data_group;
          var i;

          for (i = 0; i < persons.length; i++) {
            data_group = persons[i].groups;
          }

          if (res.data.result.contacts !== undefined) {
            var total = Math.ceil(res.data.result.contacts_count / 20);
            this.setState({ searchtotalpage: total });
            this.setState({ persons: persons });
            this.setState({ groupss: data_group });
          }
        }
      });
    }
  };
  export_Data = (e) => {
    setInterval(this.exportData(), 3000);
  };
  exportData() {
    //document.querySelector(".viewBox").style = "display:block";

    var x = this;
    x.setState({
      displayViewBox: true,
    });
    var user_id = reactLocalStorage.get("user_id_login");
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_contacts_" + user_id;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" + collectionName;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };

    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status !== "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            x.setState({
              displayViewBox: true,
            });
            x.exportDataInterval();
            x.setState({ viewDatadownload: response.data.status });
          } else if (response.data.status === "ready to download") {
            document.querySelector(".viewBox").style = "display:none";
            collectionName = response.data.file_name;
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
            x.setState({
              displayViewBox: false,
            });
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  exportDataInterval() {
    var callexport = setInterval(function() {
      var x = this;
      var user_id = reactLocalStorage.get("user_id_login");
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var collectionName = "corpsms_contacts_" + user_id;

      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" +
          collectionName;
      } else {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" + collectionName;
      }
      var headers = {
        "Content-Type": "application/json",
        token: token,
      };

      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status !== "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              x.setState({
                displayViewBox: true,
              });
              x.setState({ viewDatadownload: response.data.status });
            } else if (response.data.status === "ready to download") {
              clearInterval(callexport);
              document.querySelector(".viewBox").style = "display:none";
              collectionName = response.data.file_name;
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              }
              x.setState({
                displayViewBox: false,
              });
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 5000);
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });

    //window.scrollTo(0, 0);
    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");

    var page_num = activePage - 1;
    var data = { searchQuery: "", page: page_num };
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/searchUserContacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/searchUserContacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.status === "failed") {
        alert("token change");
      }
      if (res.data.result.contacts !== undefined) {
        const persons = res.data.result.contacts;
        if (res.data.result.contacts.length == 0) {
          document.querySelector(".icon2").style = "display:none";
        }
        var data_group;
        var i, j;

        for (i = 0; i < persons.length; i++) {
          data_group = persons[i].groups;
        }

        if (res.data.result.contacts !== undefined) {
          var total = Math.ceil(res.data.result.contacts_count / 20);
          this.setState({ totalpage: total });
          this.setState({ persons });
          this.setState({ groupss: data_group });
        }
      }
    });
  };
  handlePaginationChangeSearch = (e, { activePage }) => {
    //window.scrollTo(0, 0);
    this.setState({ activePage });

    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");

    var page_num = activePage - 1;
    var data = { searchQuery: this.state.searchWord, page: page_num };
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/searchUserContacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/searchUserContacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.status === "failed") {
        alert("token change");
      }
      if (res.data.result.contacts !== undefined) {
        const persons = res.data.result.contacts;
        if (res.data.result.contacts.length == 0) {
          document.querySelector(".icon2").style = "display:none";
        }
        var data_group;
        var i;

        for (i = 0; i < persons.length; i++) {
          data_group = persons[i].groups;
        }

        if (res.data.result.contacts !== undefined) {
          var total = Math.ceil(res.data.result.contacts_count / 20);
          this.setState({ totalpage: total });
          this.setState({ persons: persons });
          this.setState({ groupss: data_group });
        }
      }
    });
  };

  ///////////////////////////// addContact.js //////////////////
  handleChangearea = (event) => {
    this.setState({ area: event.target.value });
  };
  handleChangecountry = (event) => {
    this.setState({ country: event.target.value });
  };
  handleChangedistrict = (event) => {
    this.setState({ district: event.target.value });
  };
  handleChangegovernerate = (event) => {
    this.setState({ governerate: event.target.value });
  };

  handleChangecustom_filter1 = (event) => {
    this.setState({ custom_filter1: event.target.value });
  };
  handleChangecustom_filter2 = (event) => {
    this.setState({ custom_filter2: event.target.value });
  };
  handleChangecustom_filter3 = (event) => {
    this.setState({ custom_filter3: event.target.value });
  };
  handleChangecustom_filter4 = (event) => {
    this.setState({ custom_filter4: event.target.value });
  };
  handleChangecustom_filter5 = (event) => {
    this.setState({ custom_filter5: event.target.value });
  };
  handleChangecustom_filter6 = (event) => {
    this.setState({ custom_filter6: event.target.value });
  };

  ////////////////// addContact.js ///////////////////////
  handleChangearea = (event) => {
    this.setState({ area: event.target.value });
  };
  handleChangecountry = (event) => {
    this.setState({ country: event.target.value });
  };
  handleChangedistrict = (event) => {
    this.setState({ district: event.target.value });
  };
  handleChangegovernerate = (event) => {
    this.setState({ governerate: event.target.value });
  };

  handleChangecustom_filter1 = (event) => {
    this.setState({ custom_filter1: event.target.value });
  };
  handleChangecustom_filter2 = (event) => {
    this.setState({ custom_filter2: event.target.value });
  };
  handleChangecustom_filter3 = (event) => {
    this.setState({ custom_filter3: event.target.value });
  };
  handleChangecustom_filter4 = (event) => {
    this.setState({ custom_filter4: event.target.value });
  };
  handleChangecustom_filter5 = (event) => {
    this.setState({ custom_filter5: event.target.value });
  };
  handleChangecustom_filter6 = (event) => {
    this.setState({ custom_filter6: event.target.value });
  };

  onChangegroup = (event) => {
    console.log(event);
    /* const newArray = this.state.options_senders;
var i;
for(i=0;i<event.length;i++)
  {
    if(newArray.includes(event[i].value) === false){
      newArray.push({
        group_id:event[i].value,
        group_name:event[i].label
      });
          }
        }*/
    this.setState({ selectedValues: event }, function() {});
  };

  handleChange = (value) => {
    this.setState({ mobile: value });
    console.log(this.state.mobile);
  };

  handleChangefisrtname = (event) => {
    this.setState({ firstname: event.target.value });
    if (event.target.value.length > 15) {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Max_length_of_input_15_characters.label"),
        animation: "bounce",
        time: 5000,
      });
    }
  };

  handleChangesecondname = (event) => {
    this.setState({ secondname: event.target.value });
    if (event.target.value.length > 15) {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Max_length_of_input_15_characters.label"),
        animation: "bounce",
        time: 5000,
      });
    }
  };
  handleChangefamilyname = (event) => {
    this.setState({ familyname: event.target.value });
    if (event.target.value.length > 15) {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Max_length_of_input_15_characters.label"),
        animation: "bounce",
        time: 5000,
      });
    }
  };
  handleChangejob = (event) => {
    this.setState({ job: event.target.value });
  };
  handleChangecompany = (event) => {
    this.setState({ company: event.target.value });
  };

  handleSubmitAdd = (event) => {
    if (
      this.state.firstname.length > 15 ||
      this.state.secondname.length > 15 ||
      this.state.familyname.length > 15
    ) {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Max_length_of_input_15_characters.label"),
        animation: "bounce",
        time: 5000,
      });
    } else {
      var newarrayGroups = [];
      var i;
      for (i = 0; i < this.state.selectedValues.length; i++) {
        newarrayGroups.push({
          group_id: this.state.selectedValues[i].value,
          group_name: this.state.selectedValues[i].label,
        });
      }
      event.preventDefault();
      var x = this;
      var token = reactLocalStorage.get("accessToken");
      const user = [
        {
          mobile_number: this.state.mobile,
          first_name: this.state.firstname,
          second_name: this.state.secondname,
          family_name: this.state.familyname,
          job: this.state.job,
          company: this.state.company,
          groups: newarrayGroups,
          custom_filter1: this.state.custom_filter1,
          custom_filter2: this.state.custom_filter2,
          custom_filter3: this.state.custom_filter3,
          custom_filter4: this.state.custom_filter4,
          custom_filter5: this.state.custom_filter5,
          custom_filter6: this.state.custom_filter6,
          area: this.state.area,
          country: this.state.country,
          district: this.state.district,
          governerate: this.state.governerate,
        },
      ];
      var data = user;
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/insertContacts";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/insertContacts";
      }
      var headers = {
        "Content-Type": "application/json",
        token: token,
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function(response) {
          if (
            response.data.status === "success" &&
            response.data.result.failed_insert != 1
          ) {
            window.location = "contact";
          }
          if (response.data.result.failed_insert == 1) {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: i18n.t("duplicate_contact.label"),
              animation: "bounce",
              time: 5000,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        });
    }
  };

  goToAdd() {
    this.setState({ modalOpenAddContact: true });

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/getGroups";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/getGroups";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data != undefined) {
        const dataoption = res.data.result.groups;
        var length = res.data.result.groups.length;
        var i;
        const newArr = this.state.options_sender;
        for (i = 0; i < length; i++) {
          var value_option = dataoption[i].group_name;

          newArr.push({
            label: value_option,
            value: dataoption[i].id,
          });
        }
        groupOptions = newArr;
        this.setState({ mobile: this.state.mobile });
      }
    });
  }

  //////////////////////////// import file.js//////////////////////////////
  onChange(values) {
    const newArr = this.state.selectedValues;
    newArr.push(values);
    this.setState({
      selectedValues: newArr,
    });
  }

  /* onChangegroupImport= event =>{

const newArray = this.state.options_senders;
var i;
for(i=0;i<event.length;i++)
 {
   if(newArray.includes(event[i].value) === false){
     newArray.push(event[i].value);
         }
       }
this.setState({selectedValues: newArray}, function () {
});
}
 */

  goToImport() {
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups/0";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups/0";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data != undefined) {
        const dataoption = res.data.result.groups;
        var length = res.data.result.groups.length;
        var i;
        const newArr = this.state.options_sender;
        for (i = 0; i < length; i++) {
          var value_option = dataoption[i].group_name;
          newArr.push({
            label: value_option,
            value: dataoption[i].group_id,
          });
        }
        groupOptions = newArr;
      }
    });
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
    }
  }

  handleChangeImport = (event) => {
    event.preventDefault();
    const newArr = this.state.uploadfile;
    newArr.push(event.target.files[0]);
    this.setState({
      uploadfile: newArr,
    });

    formData.append("file", event.target.files[0]);
  };

  handleSubmitImport = (event) => {
    event.preventDefault();

    document.getElementById("contact_import_btn").disabled = true;
    document.getElementById("contact_import_btn").innerHTML = i18n.t(
      "upload_in_progress.label"
    );
    //document.getElementById("contact_import_btn").style = 'color:white;font-weight:bold;border-radius: 15px;white-space: pre;line-height: 2.5;';

    var x = this;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/importContact";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/importContact";
    }

    var data = formData;
    var headers = {
      "Content-Type": "multipart/form-data",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.result != undefined &&
            response.data.status == "success"
          ) {
            if (
              response.data.result.imported_contacts_failed === 1 &&
              response.data.result.imported_contacts_success === 1
            ) {
              toast({
                type: "warning",
                title: i18n.t("warning.label"),
                description: i18n.t("duplicate_contact.label"),
                animation: "bounce",
                time: 5000,
              });
            } else {
              x.setState({
                dataresult: response.data.result.imported_contacts_report,
              });

              total_success = response.data.result.imported_contacts_success;
              total_failed = response.data.result.imported_contacts_failed;
              x.setState({ modalIsOpen: true });
              window.location = "contact";
            }
          }

          if (response.data.status == "failed") {
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: response.data.result.result,
              animation: "bounce",
              time: 5000,
            });
            document.getElementById("contact_import_btn").disabled = false;
            document.getElementById("contact_import_btn").innerHTML = i18n.t(
              "Submit.label"
            );
          }
        } else if (response.status === 204) {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
          document.getElementById("contact_import_btn").disabled = false;
          document.getElementById("contact_import_btn").innerHTML = i18n.t(
            "Submit.label"
          );
        } else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
          document.getElementById("contact_import_btn").disabled = false;
          document.getElementById("contact_import_btn").innerHTML = i18n.t(
            "Submit.label"
          );
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  ////////////////////////////////////// EditContact.js////////////////////////
  goToEdit() {
    //this.setState({modalOpenEditContact:true})

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        reactLocalStorage.get("id_user_edit") +
        "/findcontact";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        reactLocalStorage.get("id_user_edit") +
        "/findcontact";
    }

    var object = {};
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data !== undefined) {
        this.setState({
          selectedValues: res.data.result.contact.groups,
          company: res.data.result.contact.company,
          job: res.data.result.contact.job,
          mobile: res.data.result.contact.mobile_number,
          firstname: res.data.result.contact.first_name,
          secondname: res.data.result.contact.second_name,
          familyname: res.data.result.contact.family_name,
          custom_filter1: res.data.result.contact.custom_filter1,
          custom_filter2: res.data.result.contact.custom_filter2,
          custom_filter3: res.data.result.contact.custom_filter3,
          custom_filter4: res.data.result.contact.custom_filter4,
          custom_filter5: res.data.result.contact.custom_filter5,
          custom_filter6: res.data.result.contact.custom_filter6,
          area: res.data.result.contact.area,
          country: res.data.result.contact.country,
          district: res.data.result.contact.district,
          governerate: res.data.result.contact.governerate,
        });

        /* if(res.data.result.contact.groups != undefined)
         {
           const dataoption=res.data.result.contact.groups;
           var length=res.data.result.contact.groups.length;
           var i;
           const newArr = [];
           var object={};
           var value=this.state.firstname
           this.setState({firstname:value})
           for(i=0;i<length;i++)
           {
            
            
            object={label:dataoption[i].group_name,value:dataoption[i].group_id};
            newArr.push(object)
          
           }
           this.setState({value_option: newArr})
           //this.setState({firstname:this.state.firstname})
      
         } */

        const dataoption = res.data.result.contact.groups;

        var length = res.data.result.contact.groups.length;
        console.log(length);
        if (length > 0) {
          var i;

          for (i = 0; i < length; i++) {
            object = {
              label: dataoption[i].group_name,
              value: dataoption[i].group_id,
            };
            value_option.push(object);
            data_group.push(object);
          }
          value_option = JSON.stringify(value_option);

          // this.setState({job:this.state.job})
        }
      }
    });
  }
  handleChangearea = (event) => {
    this.setState({ area: event.target.value });
  };
  handleChangecountry = (event) => {
    this.setState({ country: event.target.value });
  };
  handleChangedistrict = (event) => {
    this.setState({ district: event.target.value });
  };
  handleChangegovernerate = (event) => {
    this.setState({ governerate: event.target.value });
  };
  handleChangecustom_filter1 = (event) => {
    this.setState({ custom_filter1: event.target.value });
  };
  handleChangecustom_filter2 = (event) => {
    this.setState({ custom_filter2: event.target.value });
  };
  handleChangecustom_filter3 = (event) => {
    this.setState({ custom_filter3: event.target.value });
  };
  handleChangecustom_filter4 = (event) => {
    this.setState({ custom_filter4: event.target.value });
  };
  handleChangecustom_filter5 = (event) => {
    this.setState({ custom_filter5: event.target.value });
  };
  handleChangecustom_filter6 = (event) => {
    this.setState({ custom_filter6: event.target.value });
  };
  onChangegroupEdit = (event) => {
    groups_array = event;
  };

  onChange(values) {
    this.setState({
      selectedValues: values,
    });
  }

  handleChange = (value) => {
    this.setState({ mobile: value });
  };

  handleChangefisrtname = (event) => {
    this.setState({ firstname: event.target.value });
    if (event.target.value.length > 15) {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Max_length_of_input_15_characters.label"),
        animation: "bounce",
        time: 5000,
      });
    }
  };

  handleChangesecondname = (event) => {
    this.setState({ secondname: event.target.value });
    if (event.target.value.length > 15) {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Max_length_of_input_15_characters.label"),
        animation: "bounce",
        time: 5000,
      });
    }
  };
  handleChangefamilyname = (event) => {
    this.setState({ familyname: event.target.value });
    if (event.target.value.length > 15) {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Max_length_of_input_15_characters.label"),
        animation: "bounce",
        time: 5000,
      });
    }
  };
  handleChangejob = (event) => {
    this.setState({ job: event.target.value });
  };
  handleChangecompany = (event) => {
    this.setState({ company: event.target.value });
  };
  handleSubmitEdit = (event) => {
    event.preventDefault();
    if (
      this.state.firstname.length > 15 ||
      this.state.secondname.length > 15 ||
      this.state.familyname.length > 15
    ) {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Max_length_of_input_15_characters.label"),
        animation: "bounce",
        time: 5000,
      });
    } else {
      var token = reactLocalStorage.get("accessToken");
      var i;
      var newarrayGroups = [];
      if (groups_array.length == 0) {
        for (i = 0; i < data_group.length; i++) {
          newarrayGroups.push({
            group_id: data_group[i].value,
            group_name: data_group[i].label,
          });
        }
      } else {
        for (i = 0; i < groups_array.length; i++) {
          newarrayGroups.push({
            group_id: groups_array[i].value,
            group_name: groups_array[i].label,
          });
        }
      }
      const user = {
        mobile_number: this.state.mobile,
        first_name: this.state.firstname,
        second_name: this.state.secondname,
        family_name: this.state.familyname,
        job: this.state.job,
        company: this.state.company,
        groups: newarrayGroups,
        custom_filter1: this.state.custom_filter1,
        custom_filter2: this.state.custom_filter2,
        custom_filter3: this.state.custom_filter3,
        custom_filter4: this.state.custom_filter4,
        custom_filter5: this.state.custom_filter5,
        custom_filter6: this.state.custom_filter6,
        area: this.state.area,
        country: this.state.country,
        district: this.state.district,
        governerate: this.state.governerate,
        id: reactLocalStorage.get("id_user_edit"),
      };
      var data = user;

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/updateContact";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/updateContact";
      }

      var headers = {
        "Content-Type": "application/json",
        token: token,
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            window.location = "contact";
          } else if (response.status === 204) {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        });
    }
  };

  EditDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      //document.querySelector('.form_edit_form').style = 'text-align:right;';
    }

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/getGroups";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/getGroups";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data !== undefined) {
        const dataoption = res.data.result.groups;
        var length = res.data.result.groups.length;
        var i;
        const newArr = this.state.options_sender;
        for (i = 0; i < length; i++) {
          var value_option = dataoption[i].group_name;

          newArr.push({
            label: value_option,
            value: dataoption[i].id,
          });
        }
        groupOptions = newArr;
        this.setState({ mobile: this.state.mobile });
      }
    });
  }

  render() {
    const { activeIndex } = this.state;
    const { activePage } = this.state;
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_contact">
            <div className="main_contact ">
              <Grid columns={2} divided className="fixed_contact">
                <Grid.Row stretched className="fixed_header disable_z">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style darked_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br></br>

                <Divider horizontal>
                  <Header as="h2">
                    <Icon name="address card outline" color="black" />
                    {this.state.isArabic ? "جهات الاتصال" : "Contacts"}
                  </Header>
                </Divider>
                {this.state.displayViewBox && (
                  <div className="viewBox ">
                    <Message icon className="download_box">
                      <Icon name="circle notched" loading />
                      <Message.Content>
                        <Message.Header>Wait for downloading</Message.Header>
                        {this.state.viewData}
                      </Message.Content>
                    </Message>
                  </div>
                )}
                <br></br>

                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن رقم الهاتف"
                        : "Search By Phone Number"
                    }
                    onChange={this.searchchange.bind(this)}
                    style={{ float: "right" }}
                  />

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    disabled={this.state.exportFlag === false ? true : false}
                    onClick={this.export_Data}
                  >
                    {i18n.t("export.label")}
                    <Icon name="file excel" color="black" />
                  </Button>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenUploadFile}
                  >
                    {this.state.isArabic ? "تحميل" : "Upload"}
                    <Icon
                      name="upload"
                      color="black"
                      onClick={this.handleOpenUploadFile}
                    />
                  </Button>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.goToAdd();
                    }}
                  >
                    {this.state.isArabic
                      ? "إضافة جهة اتصال"
                      : "Add New Contact"}
                    <Icon name="pencil alternate" />
                  </Button>
                  {this.state.DeleteFlag && (
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={() => {
                        this.setState({
                          modalOpenDeleteContact: true,
                        });
                      }}
                    >
                      {i18n.t("delete.label")}
                      <Icon name="trash" color="black" />
                    </Button>
                  )}
                </div>

                <br />
                <br />
                <br></br>
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {this.state.isArabic ? "الاسم" : "Full Name"}{" "}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {this.state.isArabic ? "رقم الهاتف" : "Mobile Number"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {this.state.isArabic ? "الشركة" : "Company"}{" "}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {this.state.isArabic ? "المجموعات" : "Groups"}{" "}
                      </td>
                      <td>{this.state.isArabic ? "تعديل" : "Edit"}</td>
                      <td>{this.state.isArabic ? "حذف" : "Delete"}</td>
                    </tr>
                  </thead>
                  {this.state.persons.map((person) => (
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          {person.first_name} {person.second_name}{" "}
                          {person.family_name}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {person.mobile_number}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          {person.company}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          {person.groups.map((group) => (
                            <h>{group.group_name}</h>
                          ))}
                        </td>

                        <td style={{}}>
                          <Header as="h6">
                            <Icon
                              className="eye"
                              name="edit outline"
                              color="black"
                              id={person.id}
                              onClick={(event) => {
                                reactLocalStorage.set(
                                  "id_user_edit",
                                  event.target.id
                                );
                                this.EditContactform(event);
                              }}
                            />
                          </Header>
                        </td>

                        <td style={{}}>
                          <Header as="h6">
                            <Checkbox
                              label=""
                              style={{ width: "20%" }}
                              onClick={this.AddToDelete}
                              id={person.id}
                            />

                            {/* <Icon
                            className="eye"
                             
                              name="trash alternate outline"
                              color="black"
                              id={person.id}
                              onClick={() => {
                                this.setState({ modalOpenDeleteContact: true });
                                reactLocalStorage.set("id", person.id);
                              }}
                            /> */}
                          </Header>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </Table>

                <div className="pagination" style={{ display: "block" }}>
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        activePage={activePage}
                        onPageChange={this.handlePaginationChange}
                        totalPages={this.state.totalpage}
                        className="page_contact"
                      />
                    </Header>
                  </Divider>
                </div>

                <div className="searchpagination" style={{ display: "none" }}>
                  {" "}
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        activePage={activePage}
                        onPageChange={this.handlePaginationChangeSearch}
                        totalPages={this.state.searchtotalpage}
                        className="page_contact"
                      />
                    </Header>
                  </Divider>
                </div>
              </Segment>
            </div>

            {/* //////////////////////////////////////////////////////////////////////////////////////////////// */}
          </div>
        </div>

        <SemanticToastContainer />

        {/* //////////////Modals///////////////////// */}
        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          className="filter"
          open={this.state.modalOpenDeleteContact}
          onClose={this.handleCloseDeleteContact}
          size="small"
          style={this.state.isArabic ? DeleteContacta : DeleteContact}
        >
          <Header icon="trash" content={i18n.t("delete.label")} />
          <Modal.Content>
            <Header as="h3" textAlign="center">
              {" "}
              {i18n.t("deleteAprovalContact.label")} {"?"}{" "}
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Yes.label")}
              id={this.state.contactsIDs}
              onClick={this.handleDelete}
            />
            <Button
              basic
              color="black"
              content={i18n.t("No.label")}
              onClick={this.handleCloseDeleteContact}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          open={this.state.modalOpenEditContact}
          className="filter"
          onClose={this.handleCloseEditContact}
          style={this.state.isArabic ? AddContacta : AddContact}
        >
          <Header
            icon="edit"
            content={this.state.isArabic ? "تعديل جهة الاتصال" : "Edit Contact"}
          />

          <Modal.Content>
            <Modal.Description>
              <Header />
              <Segment>
                <Form>
                  <Segment vertical style={{ padding: "5px" }}>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("First_Name.label")}
                        placeholder={i18n.t("First_Name.label")}
                        onChange={this.handleChangefisrtname}
                        value={this.state.firstname}
                      />

                      <Form.Input
                        fluid
                        label={i18n.t("Second_Name.label")}
                        placeholder={i18n.t("Second_Name.label")}
                        onChange={this.handleChangesecondname}
                        value={this.state.secondname}
                      />

                      <Form.Input
                        fluid
                        label={i18n.t("Family_Name.label")}
                        placeholder={i18n.t("Family_Name.label")}
                        onChange={this.handleChangefamilyname}
                        value={this.state.familyname}
                      />
                    </Form.Group>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("Company.label")}
                        placeholder={i18n.t("Company.label")}
                        onChange={this.handleChangecompany}
                        value={this.state.company}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("Job.label")}
                        placeholder={i18n.t("Job.label")}
                        onChange={this.handleChangejob}
                        value={this.state.job}
                      />
                    </Form.Group>

                    <p
                      className="h6 black_color"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Mobile_Number.label")}
                    </p>

                    <PhoneInput
                      required
                      country={"jo"}
                      onChange={this.handleChange}
                      value={this.state.mobile}
                      defaultCountry={"jo"}
                      onlyCountries={["jo"]}
                      excludeCountries={["il"]}
                      inputStyle={{
                        paddingLeft: "50px",
                      }}
                    />
                  </Segment>
                  <br />
                  <Segment vertical style={{ padding: "5px" }}>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("area.label")}
                        placeholder={i18n.t("area.label")}
                        onChange={this.handleChangearea}
                        value={this.state.area}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("country.label")}
                        placeholder={i18n.t("country.label")}
                        onChange={this.handleChangecountry}
                        value={this.state.country}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("district.label")}
                        placeholder={i18n.t("district.label")}
                        onChange={this.handleChangedistrict}
                        value={this.state.district}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("governerate.label")}
                        placeholder={i18n.t("governerate.label")}
                        onChange={this.handleChangegovernerate}
                        value={this.state.governerate}
                      />
                    </Form.Group>
                  </Segment>
                  <br />
                  <Segment vertical style={{ padding: "5px" }}>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter1.label")}
                        placeholder={i18n.t("custom_filter1.label")}
                        onChange={this.handleChangecustom_filter1}
                        value={this.state.custom_filter1}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter2.label")}
                        placeholder={i18n.t("custom_filter2.label")}
                        onChange={this.handleChangecustom_filter2}
                        value={this.state.custom_filter2}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter3.label")}
                        placeholder={i18n.t("custom_filter3.label")}
                        onChange={this.handleChangecustom_filter3}
                        value={this.state.custom_filter3}
                      />
                    </Form.Group>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter4.label")}
                        placeholder={i18n.t("custom_filter4.label")}
                        onChange={this.handleChangecustom_filter4}
                        value={this.state.custom_filter4}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter5.label")}
                        placeholder={i18n.t("custom_filter5.label")}
                        onChange={this.handleChangecustom_filter5}
                        value={this.state.custom_filter5}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter6.label")}
                        placeholder={i18n.t("custom_filter6.label")}
                        onChange={this.handleChangecustom_filter6}
                        value={this.state.custom_filter6}
                      />
                    </Form.Group>
                  </Segment>
                  <br />
                  <Segment vertical style={{ padding: "5px" }}>
                    <p
                      className="h6 black_color"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Groups.label")}
                    </p>

                    <Select
                      placeholder="Select ..."
                      fluid
                      isMulti
                      search
                      selection
                      options={groupOptions}
                      onChange={this.onChangegroupEdit.bind(this)}
                      defaultValue={value_option}
                    />
                  </Segment>
                </Form>
              </Segment>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={this.handleSubmitEdit}
            />

            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseEditContact}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          open={this.state.modalOpenAddContact}
          onClose={this.handleCloseAddContact}
          style={this.state.isArabic ? AddContacta : AddContact}
          className="filter"
        >
          <Header content={i18n.t("Add_Contact.label")} />

          <Modal.Content>
            <Modal.Description>
              <Header />
              <Segment>
                <Form>
                  <Segment vertical style={{ padding: "5px" }}>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("First_Name.label")}
                        placeholder={i18n.t("First_Name.label")}
                        onChange={this.handleChangefisrtname}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("Second_Name.label")}
                        placeholder={i18n.t("Second_Name.label")}
                        onChange={this.handleChangesecondname}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("Family_Name.label")}
                        placeholder={i18n.t("Family_Name.label")}
                        onChange={this.handleChangefamilyname}
                      />
                    </Form.Group>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("Company.label")}
                        placeholder={i18n.t("Company.label")}
                        onChange={this.handleChangecompany}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("Job.label")}
                        placeholder={i18n.t("Job.label")}
                        onChange={this.handleChangejob}
                      />
                    </Form.Group>
                    <p
                      className="h6 black_color"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Mobile_Number.label")}
                    </p>

                    <PhoneInput
                      required
                      country={"jo"}
                      onChange={this.handleChange}
                      value={this.state.mobile}
                      defaultCountry={"jo"}
                      onlyCountries={["jo"]}
                      excludeCountries={["il"]}
                      inputStyle={{
                        paddingLeft: "50px",
                      }}
                    />
                  </Segment>
                  <br />
                  <Segment vertical style={{ padding: "5px" }}>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("area.label")}
                        placeholder={i18n.t("area.label")}
                        onChange={this.handleChangearea}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("country.label")}
                        placeholder={i18n.t("country.label")}
                        onChange={this.handleChangecountry}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("district.label")}
                        placeholder={i18n.t("district.label")}
                        onChange={this.handleChangedistrict}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("governerate.label")}
                        placeholder={i18n.t("governerate.label")}
                        onChange={this.handleChangegovernerate}
                      />
                    </Form.Group>
                  </Segment>
                  <br />
                  <Segment vertical style={{ padding: "5px" }}>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter1.label")}
                        placeholder={i18n.t("custom_filter1.label")}
                        onChange={this.handleChangecustom_filter1}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter2.label")}
                        placeholder={i18n.t("custom_filter2.label")}
                        onChange={this.handleChangecustom_filter2}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter3.label")}
                        placeholder={i18n.t("custom_filter3.label")}
                        onChange={this.handleChangecustom_filter3}
                      />
                    </Form.Group>
                    <Form.Group
                      widths="equal"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter4.label")}
                        placeholder={i18n.t("custom_filter4.label")}
                        onChange={this.handleChangecustom_filter4}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter5.label")}
                        placeholder={i18n.t("custom_filter5.label")}
                        onChange={this.handleChangecustom_filter5}
                      />
                      <Form.Input
                        fluid
                        label={i18n.t("custom_filter6.label")}
                        placeholder={i18n.t("custom_filter6.label")}
                        onChange={this.handleChangecustom_filter6}
                      />
                    </Form.Group>
                  </Segment>
                  <br />
                  <Segment vertical style={{ padding: "5px" }}>
                    <p
                      className="h6 black_color"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Groups.label")}
                    </p>
                    <Select
                      placeholder="Select ..."
                      fluid
                      isMulti
                      search
                      selection
                      options={groupOptions}
                      onChange={this.onChangegroup.bind(this)}
                    />
                  </Segment>
                </Form>
              </Segment>
            </Modal.Description>
          </Modal.Content>

          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={this.handleSubmitAdd}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseAddContact}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          className="add"
          open={this.state.modalOpenUploadFile}
          onClose={this.handleCloseUploadFile}
          size="small"
          style={this.state.isArabic ? DeleteContacta : DeleteContact}
        >
          <Header icon="upload" content={i18n.t("Import.label")} />
          <Modal.Content>
            <Form
              style={{
                textAlign:
                  reactLocalStorage.get("lang") === "ar" ? "right" : "left",
              }}
            >
              <a
                style={{ float: this.state.isArabic ? "right" : "" }}
                href={require("../pictures/sample.csv")}
                download
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "red",
                  cursor: "pointer",
                }}
              >
                {i18n.t("Click_to_download_sample.label")}
              </a>
              <br />
              <Form.Input
                type="file"
                ref={(input) => {
                  this.filesInput = input;
                }}
                fluid
                label={i18n.t("UploadCSV.label")}
                placeholder={i18n.t("UploadCSV.label")}
                onChange={this.handleChangeImport}
                width={16}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={(this, this.handleSubmitImport)}
              id="contact_import_btn"
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseUploadFile}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(Contact);
